export * from './equipments.component';
export * from './equipments-list';
export * from './equipments-new';
export * from './equipments-edit';
